/* eslint-disable react/jsx-props-no-spreading */
import { ReactElement } from 'react'
import Typography, { TypographyProps } from '@mui/material/Typography'
import clsx from 'clsx'

import { Sujeto } from 'src/interfaces'
import { isOrganoJudicial, isProfesional } from 'src/utils/sujeto'

interface Props extends TypographyProps {
  sujeto: Sujeto
}

export default function Codigo({ sujeto, ...rest }: Props): ReactElement | null {
  if (isOrganoJudicial(sujeto)) {
    return (
      <Typography {...rest} className={clsx(rest.className)}>
        {sujeto.nombre}
      </Typography>
    )
  }
  if (isProfesional(sujeto)) {
    return (
      <Typography {...rest} className={clsx(rest.className)}>
        Código Colegiado: {sujeto.codigoColegiado}
      </Typography>
    )
  }
  return null
}
